/**
 * @generated SignedSource<<0204a83ef573f9a941f59a73dd99d3a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDueDateModal_todo$data = {
  readonly dueDate: DateString  | null;
  readonly id: string;
  readonly " $fragmentType": "TodoDueDateModal_todo";
};
export type TodoDueDateModal_todo$key = {
  readonly " $data"?: TodoDueDateModal_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDueDateModal_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDueDateModal_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueDate",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "d7aeeaf13bf42be0980a57557b382989";

export default node;
